import script from "./SearchField.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchField.vue?vue&type=script&setup=true&lang=js"

import "./SearchField.vue?vue&type=style&index=0&id=c56fa180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c56fa180"]])

export default __exports__